import { render, staticRenderFns } from "./robduration.vue?vue&type=template&id=1618d7dc&scoped=true&"
import script from "./robduration.vue?vue&type=script&lang=js&"
export * from "./robduration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1618d7dc",
  null
  
)

export default component.exports